// extracted by mini-css-extract-plugin
export default {"addon-before":"with-addons_addon-before__gG+pw","addon-after":"with-addons_addon-after__GeetQ"};